<script setup lang="ts">
import ScDrag from '@/components/common/drag/ScDrag';
import { ref } from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { proxyTip } from '@/views/management/common/util';

const props = defineProps<{
  level: number;
  data: any;
  source: string;
  remove?: () => void;
}>();
const line = ref();
</script>

<template>
  <sc-drag
    format="node"
    :data="JSON.stringify({ data, source })"
    :img="{ el: line }"
  >
    <div class="line" ref="line" :style="`margin-left: ${level * 22}px`">
      <div class="content sub">
        <sc-icon type="MobileTwoTone" />
        <a-tooltip
          placement="right"
          :overlayStyle="{ whiteSpace: 'pre-line' }"
          :title="proxyTip(data)"
        >
          <div class="td">
            {{ data.username }} | {{ data.typeText }}://{{ data.host }}:{{
              data.port
            }}
          </div>
        </a-tooltip>
        <a-tag color="blue" v-if="data.group">
          {{ data.group?.name }}
        </a-tag>
        <template v-if="data.tags">
          <a-tag color="green" v-for="(item, k) in data.tags.list" :key="k">
            {{ item.name }}
          </a-tag>
        </template>
        <div class="td" v-if="data.remark">
          {{ data.remark }}
        </div>
        <template v-if="level > 0">
          <div style="flex-grow: 1; border-bottom: 2px dotted #1da57a" />
          <sc-btn type="link" :handler="remove" text="移除" v-if="remove" />
        </template>
      </div>
    </div>
  </sc-drag>
</template>

<style scoped lang="scss">
.line {
  display: flex;
  flex-direction: row;
  align-items: center;

  .arrow {
    flex-shrink: 0;
    width: 22px;
    height: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #363636;
    padding-right: 6px;
  }

  .checkbox {
    margin-right: 6px;
  }

  .title {
    flex-grow: 1;
    padding-left: 6px;
  }

  &.active {
    .title {
      //background-color: #82c3ff;
    }
  }
}

.content {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  &.hover {
    background: #15c890;
    color: #fff;
  }

  .td {
    padding: 0 8px;
  }
}
</style>
